import React from 'react';
import { FileSignature, Wrench, Receipt, FileBarChart, ScrollText, Building2 } from 'lucide-react';

const TYPES = [
  {
    icon: FileSignature,
    title: 'Lease lifecycle docs',
    body:
      'Rental applications, screening reports, signed leases, lease addenda, pet agreements, parking assignments, renewal notices, rent change notices, lease violations, eviction filings, move-out inspections, security deposit disposition letters. Each routes under the active lease, with the lease folder lifecycle preserved.',
  },
  {
    icon: Wrench,
    title: 'Maintenance reports and work orders',
    body:
      'Vendor invoices for plumbing, HVAC, electrical, pest control, painting, and turnover work. Sortio reads each one for the property, unit, work order number, vendor name, and service date. Routes under the matching unit and links to the originating work order when one is referenced.',
  },
  {
    icon: Receipt,
    title: 'Vendor invoices and 1099 prep',
    body:
      'AP invoices from cleaning crews, landscapers, snow removal, HOA dues, utility bills. Sortio recognizes recurring vendors and routes by property and expense category. At year end, the same routing produces a clean per-vendor folder for 1099-NEC preparation across all your properties.',
  },
  {
    icon: FileBarChart,
    title: 'Owner statements and reports',
    body:
      'Monthly owner statements, cash flow reports, year-end summaries, capital improvement schedules. Sortio splits these by owner and routes into per-owner folders so handoff to a CPA or to the owner directly is one folder deep.',
  },
  {
    icon: Building2,
    title: 'Tenant ledgers and correspondence',
    body:
      'Tenant payment ledgers, NSF notices, late fee assessments, three-day notices, written correspondence with tenants about repairs or complaints. Each routes under the active lease, with date ordering so a dispute history is easy to reconstruct.',
  },
  {
    icon: ScrollText,
    title: 'Compliance and regulatory docs',
    body:
      'Fair Housing complaints, Section 8 paperwork, HUD inspection reports, local code violation notices, registration certificates, business licenses. Routed into a compliance folder per property with retention tags so audits are answerable.',
  },
];

const DocumentTypes = () => {
  return (
    <section id="document-types" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Document types Sortio recognizes
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          The categories that show up across a typical month of property management work.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TYPES.map((type, i) => {
          const Icon = type.icon;
          return (
            <div key={i} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6">
              <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-primary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{type.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{type.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default DocumentTypes;
